import React from 'react';
import PropTypes from 'prop-types';

const DropdownOptions = ({
  options,
  multiSelect,
  values,
  onSelect,
}) => (
  <div className="open-d-w-t">
    <div className="open-d-w-t-wrp">
      {options.map((item) => {
        const isItemCurrentlySelected = values.includes(item.value);

        return item.countryAlias
          ? (
            <div
              onClick={(e) => onSelect(e, item)}
              className={`app-dropdown-wrapper ${isItemCurrentlySelected ? 'active' : ''}`}
              key={item.value}
            >
              {multiSelect && isItemCurrentlySelected && <span className="dr-icon global-icon icon-check-mark" style={{ marginRight: '8px' }} />}
              <span
                className={`flag icon-${(item.flagAlias || item.countryAlias)?.toLowerCase()} flag`}
              />
              <p>
                {item.name}
              </p>
            </div>
          ) : (
            <p
              key={item.value}
              className={isItemCurrentlySelected ? 'active' : ''}
              onClick={(e) => onSelect(e, item)}
            >
              {multiSelect && isItemCurrentlySelected && <span className="dr-icon global-icon icon-check-mark" style={{ marginRight: '8px' }} />}
              {item.name}
            </p>
          );
      })}
    </div>
  </div>
);

DropdownOptions.propTypes = {
  multiSelect: PropTypes.bool,
  options: PropTypes.array,
  values: PropTypes.array,
  onSelect: PropTypes.func,
};

export default DropdownOptions;
